import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { Sidebar } from 'src/components/sidebar/Sidebar';

interface Props {
  sidebarContent?: React.ReactNode;
  children: React.ReactNode;
}

export const SidebarLayout = ({ sidebarContent, children }: Props) => {
  const mainRef = useRef<HTMLElement>(null);
  const location = useLocation();

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className="flex h-full flex-col overflow-hidden sm:flex-row">
      <Sidebar>
        <div className="flex flex-auto flex-col items-stretch justify-between overflow-hidden overflow-y-auto">
          {sidebarContent}
        </div>
      </Sidebar>
      <main
        className="flex h-full flex-auto flex-col overflow-hidden overflow-y-auto border-l border-primary bg-primary"
        ref={mainRef}
      >
        <div className="mx-auto flex w-full max-w-3/4 flex-col sm:m-auto">
          {children}
        </div>
      </main>
    </div>
  );
};
